import React, { Component } from 'react';

class Email extends Component {
  render() {
    return(
      <div className='tooltip center'>
          <img src={require('../assets/tick.svg')} alt='All Levels Complete!' />
          <div>
            <p>You learned all available Hanja for now. <br /> Good job! Why not go back and review?</p>
            <p> Enter your email to get notified of new Hanja and learning modes.</p>
          </div>
          <div id="mc_embed_signup">
          <form action="//tltalk.us12.list-manage.com/subscribe/post?u=0907bcabbf38a76d75945f031&amp;id=f55f6e69ce" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" noValidate>
            <div id="mc_embed_signup_scroll">

          <input type="email" name="EMAIL" id="mce-EMAIL" placeholder="Email Address" required />
            <div className="clear"><button type="submit" value="Get Notified" name="subscribe" id="mc-embedded-subscribe">Get Notified</button></div>
            </div>
          </form>
          </div>
      </div>

    )
  }
}
export default Email;



// WEBPACK FOOTER //
// ./src/components/email.js